declare namespace $ {

	type $mol_string__value_shm_mentionstat_form_1 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_shm_mentionstat_form_3 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['query_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_4 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Query'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_mentionstat_form_5 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['excluded_words'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_7 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Excluded_words'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_period__date_from_shm_mentionstat_form_8 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['date_from'] >
		,
		ReturnType< $shm_period['date_from'] >
	>
	type $shm_period__date_to_shm_mentionstat_form_9 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['date_to'] >
		,
		ReturnType< $shm_period['date_to'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_shm_mentionstat_form_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_string__value_shm_mentionstat_form_12 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['country'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_14 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Country'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_shm_mentionstat_form_15 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['language'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_17 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Language'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_file_drop__accept_shm_mentionstat_form_18 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_file_drop['accept'] >
	>
	type $shm_file_drop__files_shm_mentionstat_form_19 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['social_files'] >
		,
		ReturnType< $shm_file_drop['files'] >
	>
	type $mol_view__sub_shm_mentionstat_form_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_shm_mentionstat_form_22 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['files_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__content_shm_mentionstat_form_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $shm_file_drop__accept_shm_mentionstat_form_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_file_drop['accept'] >
	>
	type $shm_file_drop__files_shm_mentionstat_form_25 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['mass_files'] >
		,
		ReturnType< $shm_file_drop['files'] >
	>
	type $mol_view__sub_shm_mentionstat_form_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_shm_mentionstat_form_28 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['files_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__content_shm_mentionstat_form_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_select__value_shm_mentionstat_form_30 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['search_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_mentionstat_form_31 = $mol_type_enforce<
		({ 
			'инфоповод': string,
			'компания': string,
			'персона': string,
			'событие': string,
			'процесс': string,
			'география': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_33 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Type'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_shm_mentionstat_form_34 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['tags'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_36 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Tags'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_shm_mentionstat_form_37 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['category'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_mentionstat_form_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_mentionstat_form_39 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['Category'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form_group__sub_shm_mentionstat_form_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_form_group__sub_shm_mentionstat_form_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_form_group__sub_shm_mentionstat_form_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_form_group__sub_shm_mentionstat_form_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_button_major__title_shm_mentionstat_form_44 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['submit_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_mentionstat_form_45 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['submit_allowed'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_mentionstat_form_46 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_mentionstat_form_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_mentionstat_form_48 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_form['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_mentionstat_form extends $mol_form {
		query_bid( ): string
		query( next?: string ): string
		Query( ): $mol_string
		Query_field( ): $mol_form_field
		excluded_words( next?: string ): string
		Excluded_words( ): $mol_textarea
		Excluded_words_field( ): $mol_form_field
		date_from( next?: string ): string
		date_to( next?: string ): string
		Period( ): $shm_period
		Period_field( ): $mol_form_field
		country( next?: string ): string
		Country( ): $mol_string
		Country_field( ): $mol_form_field
		language( next?: string ): string
		Language( ): $mol_string
		Language_field( ): $mol_form_field
		files_bid( ): string
		social_files( next?: readonly(File)[] ): readonly(File)[]
		Social_upload( ): $shm_file_drop
		social_title( ): string
		Social_title( ): $mol_view
		Social_field( ): $mol_form_field
		mass_files( next?: readonly(File)[] ): readonly(File)[]
		Mass_upload( ): $shm_file_drop
		mass_title( ): string
		Mass_title( ): $mol_view
		Mass_field( ): $mol_form_field
		search_type( next?: string ): string
		Type( ): $mol_select
		Type_field( ): $mol_form_field
		tags( next?: string ): string
		Tags( ): $mol_string
		Tags_field( ): $mol_form_field
		category( next?: string ): string
		Category( ): $mol_string
		Category_field( ): $mol_form_field
		Query_group( ): $mol_form_group
		Locale_group( ): $mol_form_group
		Files_group( ): $mol_form_group
		Meta_group( ): $mol_form_group
		submit_allowed( ): boolean
		submit( next?: any ): any
		Submit( ): $mol_button_major
		reset( next?: any ): any
		Reset( ): $mol_button_minor
		social_existing_title( ): string
		mass_existing_title( ): string
		submit_title( ): string
		form_fields( ): readonly(any)[]
		body( ): readonly(any)[]
		buttons( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map